<template>
  <slider v-model="slideIndex"
          :touch="allowSlide"
          :control-btn="false"
          :autoplay="autoplay"
          :animation="animation"
          :height="height"
          :width="width"
          :indicators="indicators"
          class="slider-component"
          @change="indicatorChange">
    <slider-item v-for="(component, index) in listComponents" :key="index">
      <div class="slider-content">
        <component :is="component"
                   :card-details="sliderDetails" />
      </div>
      <slot name="banner"></slot>
    </slider-item>
  </slider>
</template>

<script>
  import { Slider, SliderItem } from 'vue-easy-slider';

  export default {
    name: "slider-component",
    props: {
      sliderDetails: {type: Object},
      initialSliderIndex: {type: Number, default: 0},
      listComponents: {type: Array},
      height: {type: String, default: '400px'},
      width: {type: String, default: 'auto'},
      autoplay: {type: Boolean, default: false},
      animation: {type: String, default: 'fade'}, //normal or fade
      allowSlide: {type: Boolean, default: true}, //enables swiping behavior on mobile
      indicators: {type: [String, Boolean], default: 'center'}, // ('center', 'left', 'right', false).. set to false if will be using own pagination
    },
    components:{
      Slider,
      SliderItem,
    },
    data() {
      return {
        slideIndex: this.initialSliderIndex,
      }
    },
    methods: {
      next() {
        if (this.slideIndex < this.listComponents.length) {
          this.slideIndex++;
        }
      },
      previous() {
        if (this.slideIndex >= 0) {
          this.slideIndex--;
        }
      },
      indicatorChange(index) {
        this.$emit('current-step', index);
      },
    },
  }
</script>

<style lang="scss">
  @import "~@/assets/styles/util.scss";

  .slider-component {
    @extend %show-overflow;

    .slider-indicators {
      bottom: 0px !important;

      &>*:not(:last-child) {
        margin: 0 space(s) 0 0 !important;
      }

      & > :last-child{
        margin: 0 !important;
      }
    }

    .slider-indicator-icon {
      background-color: color(gray-200) !important;
    }

    .slider-indicator-active {
      background-color: color(dodgerBlue) !important;
    }
  }
</style>
